import { useAuth0 } from '@auth0/auth0-react';
import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { getAuthErrorCode } from '~/errors/auth-error';

export function useAuthentication() {
  const { isLoading, isAuthenticated, user, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    async function initializeAuthentication() {
      const requestedOrganization = searchParams.get('organization');
      const orgMismatch = !!requestedOrganization && !!user && user.org_id !== requestedOrganization;

      if (isAuthenticated && !orgMismatch) {
        try {
          await getAccessTokenSilently();
        } catch (err) {
          Sentry.captureException(err, {
            extra: { authErrorCode: getAuthErrorCode(err) },
            tags: { authTokenRefresh: 'failed' },
          });
          await loginWithRedirect();
        }
      }

      if ((!isAuthenticated || orgMismatch) && !isLoading && requestedOrganization) {
        const invitationId = searchParams.get('invitation');
        const connection = searchParams.get('connection');
        const authorizationParams = {
          ...(invitationId ? { invitation: invitationId } : {}),
          ...(connection ? { connection } : {}),
          organization: requestedOrganization,
        };

        try {
          await loginWithRedirect({
            authorizationParams,
          });
        } catch (err) {
          console.error(err);
        }
        return;
      }

      if (!isAuthenticated && !isLoading) {
        try {
          await loginWithRedirect();
        } catch (err) {
          console.error(err);
        }
      }
    }
    initializeAuthentication();
  }, [isAuthenticated, isLoading, searchParams, loginWithRedirect, getAccessTokenSilently, user]);

  return { isAuthenticated, isLoading };
}
